import { memo } from "react";
import { MathJaxHtml } from "../../../../../../components/mathJax/MathJaxHtml";
import type { QuestionData } from "../../models/GetQuestions";
import { cleanMathML, getOptionState } from "../selection/optionState";
import styles from "../selection/SelectionOptions.module.scss";

type Props = {
  content: string | null | undefined;
  isSelected: boolean;
  onPress: () => void;
  questionData: QuestionData;
  optionIndex: number;
  correctPositions: number[];
};

const SingleSelectionWebInner = ({
  content,
  isSelected,
  onPress,
  questionData,
  optionIndex,
  correctPositions,
}: Props) => {
  const isThisOptionCorrect = correctPositions.includes(optionIndex + 1);
  const state = getOptionState({
    isAttempted: questionData?.isAttempted,
    isSelected,
    isThisOptionCorrect,
  });

  const rowClass =
    state === "correct"
      ? styles.optionCorrect
      : state === "wrong"
        ? styles.optionWrong
        : state === "selected"
          ? styles.optionSelected
          : styles.optionDefault;

  const disabled = !!questionData?.isAttempted;

  return (
    <button
      type="button"
      className={`${styles.optionRow} ${rowClass}`}
      disabled={disabled}
      onClick={() => {
        if (!disabled) onPress();
      }}
    >
      <span className={styles.radioOuter} aria-hidden>
        {isSelected && <span className={styles.radioDot} />}
      </span>
      <span className={styles.optionMath}>
        <MathJaxHtml
          content={cleanMathML(content)}
          className={styles.reviseTextMathStyle}
        />
      </span>
    </button>
  );
};

export const SingleSelectionWeb = memo(
  SingleSelectionWebInner,
  (prev, next) =>
    prev.content === next.content &&
    prev.isSelected === next.isSelected &&
    prev.optionIndex === next.optionIndex &&
    prev.questionData.isAttempted === next.questionData.isAttempted &&
    prev.correctPositions === next.correctPositions &&
    prev.onPress === next.onPress,
);
